<template>
    <div class="container-fluid" >
        <grid
            controllers='true' 
            :titles='titles'
            :data='contents'
            current-sort="Mes"
            search-key="DESCRICAO"
        />
    </div>
</template>
<script>
import grid from '@/components/grid.vue'
export default {
    name: 'vwReportBillsToReceive',
    data(){
        return {
            titles: ['Descrição', 'Vencimento', 'Valor'],
            contents: []
        }
    },
    components: {
        grid
    },
    computed: {
        getRouteParam(){
            return this.$route.params.id
        },
        getToken(){
            return this.$store.getters.getToken
        }
    },
    methods: {
        getData: function(){
            fetch(server + 'getbillstopaypermonth?token=' + this.getToken + '&period=' + this.getRouteParam)
                .then(response => (response.json()))
                .then(responseJSON => {
                    let data = responseJSON.data
                    data.forEach(element => {
                        this.contents.push(element)
                    });
                })
                .catch(error => {
                    console.log('Error exception', '=>', error)
                })
        }
    },
    mounted(){
        this.getData()
    }
}
</script>
<style scoped>

</style>